export default {
  items: [
    {
      name: 'Exames Pendentes',
      url: '/examViewer',
      icon: 'fa fa-heartbeat'
    },
      
    {
      name: 'Fila de Exames',
      url: '/examQueue',
      icon: 'icon-list'
    },

    {
      name: 'Pesquisa Avançada',
      url: '/examSearch',
      icon: 'icon-docs'
    },

    {
      name: 'Logout',
      url: '/logout',
      icon: 'icon-lock'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_navDoctor.js